// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */section.section.section-search-vacancy[data-v-6c5a60a6]{overflow:unset}.breadcrumbs-vacancy[data-v-6c5a60a6]{margin-bottom:2.4rem}@media (max-width:767px){.breadcrumbs-vacancy[data-v-6c5a60a6]{display:none}}.title-filters[data-v-6c5a60a6]{color:var(--text-primary);margin-bottom:9.6rem}@media (max-width:767px){.title-filters[data-v-6c5a60a6]{margin-bottom:4.8rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
